import { useEffect } from 'react'
import { PANEL_SESSION_REFRESH_MS, refreshPanelSession } from '../utils/panelSession'

/** 面板用户进入订单页后自动续期 JWT（默认每次顺延 1 天） */
export function usePanelSessionRefresh(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return

    const renew = () => {
      void refreshPanelSession()
    }

    renew()

    const timer = window.setInterval(renew, PANEL_SESSION_REFRESH_MS)
    const onFocus = () => renew()
    const onVisibility = () => {
      if (document.visibilityState === 'visible') renew()
    }

    window.addEventListener('focus', onFocus)
    document.addEventListener('visibilitychange', onVisibility)

    return () => {
      window.clearInterval(timer)
      window.removeEventListener('focus', onFocus)
      document.removeEventListener('visibilitychange', onVisibility)
    }
  }, [enabled])
}
